import React from 'react';
import FormContactEn from './FormContactEn';
import FormContactFr from './FormContactFr';
import FormVideoHelpFr from './FormVideoHelpFr';
import FormVideoHelpEn from './FormVideoHelpEn';
import FormFeedbackEn from './FormFeedbackEn';
import FormFeedbackFr from './FormFeedbackFr';

const StaticPageForm = () => {
    const selectForm = () => {
        const { pathname } = window.location;

        switch (pathname) {
            case "/contact-us":
                return <FormContactEn/>;
            case "/contactez-nous":
                return <FormContactFr/>;
            case "/video-help":
                return <FormVideoHelpEn/>;
            case "/aide-videos":
                return <FormVideoHelpFr/>;
            case "/accessibility":
                return <FormFeedbackEn />;
            case "/accessibilite":
                return <FormFeedbackFr />
            default:
                return null;
        }
    }

    return selectForm();
}

export default StaticPageForm;